// test65
(65 && 0);
